import { render } from "./UserProfile.vue?vue&type=template&id=65be9ed6"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"
script.render = render

export default script